import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { FileTextIcon, TableIcon, CheckSquareIcon } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function ProductDetailsSection() {
  return <>
      <Section background="white" data-id="element-148">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-149">
          <div data-id="element-150">
            <h2 className="text-3xl md:text-4xl text-[#2D3B2D] mb-8" data-id="element-151">
              Qué incluye exactamente
            </h2>
            <div className="space-y-8" data-id="element-152">
              <div className="flex gap-4" data-id="element-153">
                <div className="bg-[#FDF8F0] p-3 rounded-lg h-fit" data-id="element-154">
                  <FileTextIcon className="text-[#C4A962]" size={24} data-id="element-155" />
                </div>
                <div data-id="element-156">
                  <h3 className="font-bold text-[#2D3B2D] text-lg mb-1" data-id="element-157">
                    PDF Plan Antipánico de Deudas (30 días)
                  </h3>
                  <p className="text-[#4A5D4A]" data-id="element-158">
                    Lectura fácil, cero jerga. Tu guía paso a paso.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-159">
                <div className="bg-[#FDF8F0] p-3 rounded-lg h-fit" data-id="element-160">
                  <TableIcon className="text-[#C4A962]" size={24} data-id="element-161" />
                </div>
                <div data-id="element-162">
                  <h3 className="font-bold text-[#2D3B2D] text-lg mb-1" data-id="element-163">
                    Plantilla Google Sheets (copy-paste)
                  </h3>
                  <p className="text-[#4A5D4A]" data-id="element-164">
                    Lista de deudas + orden de ataque, detector de fugas,
                    calendario 30 días, mini fondo.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-165">
                <div className="bg-[#FDF8F0] p-3 rounded-lg h-fit" data-id="element-166">
                  <CheckSquareIcon className="text-[#C4A962]" size={24} data-id="element-167" />
                </div>
                <div data-id="element-168">
                  <h3 className="font-bold text-[#2D3B2D] text-lg mb-1" data-id="element-169">
                    Checklists imprimibles
                  </h3>
                  <p className="text-[#4A5D4A]" data-id="element-170">
                    Semana 1–4, Lista anti-impulso (sustitución), Protocolo "mes
                    malo".
                  </p>
                </div>
              </div>
            </div>

            {/* CTA after "Qué incluye" */}
            <div className="mt-10" data-id="element-171">
              <p className="text-sm text-[#2D3B2D] mb-3 italic" data-id="element-172">
                Si quieres salir del mínimo y tener orden hoy, aquí es:
              </p>
              <Button icon onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-173">
                Sí, quiero el Plan Antipánico
              </Button>
            </div>
          </div>

          <div className="bg-[#FDF8F0] p-8 md:p-10 rounded-3xl border border-[#E8EDE6]" data-id="element-174">
            <h3 className="text-2xl font-serif text-[#2D3B2D] mb-6" data-id="element-175">
              Cómo se ve el cambio
            </h3>
            <p className="text-[#4A5D4A] mb-6" data-id="element-176">
              No te voy a decir que "tu vida se transforma en 24 horas". Pero sí
              pasa algo muy concreto:
            </p>
            <ul className="space-y-4 mb-8" data-id="element-177">
              <li className="flex items-start text-[#2D3B2D] font-medium" data-id="element-178">
                <span className="w-2 h-2 bg-[#C4A962] rounded-full mr-3 mt-1.5 flex-shrink-0" data-id="element-179" />
                Dejas de evitar mirar
              </li>
              <li className="flex items-start text-[#2D3B2D] font-medium" data-id="element-180">
                <span className="w-2 h-2 bg-[#C4A962] rounded-full mr-3 mt-1.5 flex-shrink-0" data-id="element-181" />
                Dejas de improvisar
              </li>
              <li className="flex items-start text-[#2D3B2D] font-medium" data-id="element-182">
                <span className="w-2 h-2 bg-[#C4A962] rounded-full mr-3 mt-1.5 flex-shrink-0" data-id="element-183" />
                Empiezas a ver avance (aunque sea pequeño)
              </li>
              <li className="flex items-start text-[#2D3B2D] font-medium" data-id="element-184">
                <span className="w-2 h-2 bg-[#C4A962] rounded-full mr-3 mt-1.5 flex-shrink-0" data-id="element-185" />
                El ruido mental baja, porque hay un plan
              </li>
            </ul>
            <p className="text-sm text-[#4A5D4A] italic" data-id="element-186">
              Y cuando el ruido baja… compras menos por ansiedad.
            </p>
          </div>
        </div>
      </Section>

      {/* Pricing Section */}
      <Section id="pricing" background="cream" className="text-center" data-id="element-187">
        <div className="max-w-xl mx-auto bg-white p-10 rounded-3xl shadow-xl border border-[#E8EDE6] relative overflow-hidden" data-id="element-188">
          <div className="absolute top-0 left-0 w-full h-2 bg-[#C4A962]" data-id="element-189" />

          <h2 className="text-3xl md:text-4xl font-serif text-[#2D3B2D] mb-2" data-id="element-190">
            Plan Antipánico de Deudas
          </h2>
          <p className="text-sm text-[#4A5D4A] mb-6" data-id="element-191">(30 días)</p>

          <div className="flex justify-center items-baseline gap-3 mb-1" data-id="element-192">
            <span className="text-xl text-[#4A5D4A] line-through opacity-60" data-id="element-193">
              Antes $19
            </span>
            <span className="text-lg text-[#4A5D4A]" data-id="element-194">Hoy</span>
            <span className="text-5xl font-bold text-[#2D3B2D]" data-id="element-195">$6.36</span>
            <span className="text-[#4A5D4A] ml-1" data-id="element-196">USD</span>
          </div>

          <p className="text-xs text-[#4A5D4A]/60 mb-3" data-id="element-197">
            Precio promocional actual.
          </p>

          <span className="inline-block px-4 py-1.5 mb-4 text-xs font-bold tracking-wide uppercase bg-[#C4A962]/15 text-[#C4A962] rounded-full" data-id="element-198">
            Pago único · Sin suscripción
          </span>

          <p className="text-[#4A5D4A] mb-4 text-sm" data-id="element-199">
            Menos que una compra impulsiva "chiquita" que luego te deja culpa.
          </p>

          <p className="text-[#4A5D4A] mb-8 text-xs" data-id="element-200">
            Incluye acceso inmediato al PDF + plantilla + checklists. Sin
            suscripción. Sin llamadas. Sin letras pequeñas.
          </p>

          <Button fullWidth className="mb-4" href="https://momentumdigitalpro.com/cart/44521034743910:1" onClick={trackAddToCart} data-id="element-201">
            Sí, quiero el Plan Antipánico
          </Button>

          <p className="text-xs text-[#4A5D4A]/80 mt-4" data-id="element-202">
            Si tienes algún problema con la descarga o acceso, escríbenos y te
            reenviamos el archivo / enlace de acceso.
          </p>
        </div>
      </Section>
    </>;
}